import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Animated progress bar with optional label.
 */
const Progress = React.forwardRef(({ className, value = 0, label, showPercent = true, color = 'bg-blue-500', ...props }, ref) => {
    const clampedValue = Math.max(0, Math.min(100, value));

    return (
        <div ref={ref} className={cn("w-full", className)} {...props}>
            {(label || showPercent) && (
                <div className="flex items-center justify-between mb-1">
                    {label && <span className="text-xs text-zinc-500 dark:text-zinc-400">{label}</span>}
                    {showPercent && <span className="text-xs font-mono text-zinc-400">{Math.round(clampedValue)}%</span>}
                </div>
            )}
            <div className="h-2 w-full bg-zinc-200 dark:bg-zinc-700 rounded-full overflow-hidden">
                <div
                    className={cn("h-full rounded-full transition-all duration-500 ease-out", color)}
                    style={{ width: `${clampedValue}%` }}
                />
            </div>
        </div>
    );
});

Progress.displayName = "Progress";

export { Progress };
